'use strict';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/takeUntil';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {assignOrganizationToModel, hydrateOrganization, selectedOrganization} from '../../app/model/actions';


/**
 * @typedef {Object} AssetProjectListSupportEpicsOptions
 * @property {ReduxObservableListActions} actions
 * @property {Function} getState
 * @property {String} viewName The ui-router state name for the list view
 * @property {bunyan} logger
 */

/**
 * @param {AssetProjectListSupportEpicsOptions} options
 */
export function buildListSupportEpics(options) {
  const actions = options.actions;
  const logger = options.logger;

  return [
    onModelChangeEpic,
  ];

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @return {Observable.<ReduxAction>}
   */
  function onModelChangeEpic(action$, store) {
    // listen to all actions that may trigger a project change and map to the new project ID.
    // on change, trigger list destruction and, if there is a new id selected, init the new one.
    return action$.ofType(actions.initList.TYPE)
      .switchMap(action =>
        Observable.merge(
          action$.ofType(selectedOrganization.TYPE).map(selectAction => selectAction.payload.id),
          action$.ofType(hydrateOrganization.TYPE).map(selectAction => selectAction.payload.nextOrgId),
          action$.ofType(assignOrganizationToModel.TYPE).map(assignAction => getId(assignAction.payload.organization)),
        )
          .filter(nextId => nextId !== action.payload.parentId)
          .take(1)
          .map(nextId => ({
            prevParentId: action.payload.parentId,
            nextParentId: nextId,
          }))
          .takeUntil(
            action$.ofType(actions.destroyList.TYPE)
              .filter(destroyAction => destroyAction.meta.parentId === action.payload.parentId)
          )
      )
      .mergeMap(({prevParentId, nextParentId}) => nextParentId
        ? Observable.of(
          actions.destroyList(void 0, {parentId: prevParentId}),
          actions.initList({parentId: nextParentId}),
        )
        : Observable.of(actions.destroyList(void 0, {parentId: prevParentId})))
      .catch(epicErrorHandler(logger, 'onModelChangeEpic'));
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/epics/listSupportEpics.js